import { modules } from '@veritone/glc-redux';
const {
  config: { getConfig },
} = modules;

const getSchemasRequired = (state: any) => {
  const config = getConfig<Window['config']>(state);
  return config.schemasRequired;
};
export default getSchemasRequired;
